import type { FaireProductEntity } from "../../entity_types/product";

export const p_2rz62645xn: FaireProductEntity = {
  token: "p_2rz62645xn",
  type: "product",
  name: "Custom Embroidered Toddler & Youth Sweatshirt – Town & State",
  brandToken: "b_bftwxtye3z",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/db2829cc8105e9570e2d751649c201da48de9d0be316785226157eb9dae2eb34.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dd481826e80550d4addb5d56823616436f6b7237d7d58d66f444cddd1f10c475.jpeg",
    "https://cdn.faire.com/fastly/dcd0a1c5cfb355de12780760c8868d1d6c127497c23b7f5c64632029528e4573.jpeg",
    "https://cdn.faire.com/fastly/528d54cb485e39d5b95d2884c2bdf4536795a65aec3384b69abb2c46db2a2c3f.jpeg",
    "https://cdn.faire.com/fastly/a8245e8c439e32bf3bd9439ff73a42c7f5eb9fb6f3287bca18017834edae5314.webp",
    "https://cdn.faire.com/fastly/4af7fb0b2061aef16c8cb43c3013239577a4ccd84faf39eee90a93fc2bebf630.png",
  ],
  priceDollars: 26.33,
  description:
    "A cozy, keepsake-style sweatshirt designed for little locals and hometown pride. This custom embroidered toddler and youth sweatshirt features your chosen town and state, stitched in clean, high-quality embroidery that feels timeless and personal.\n\nPerfect for boutiques in tourist towns, gift shops, and local markets, this sweatshirt makes a meaningful souvenir, everyday layer, or thoughtful gift. Each piece is made to order, with the option to choose your own embroidery colors or let us curate a color palette that complements your shop’s aesthetic and towns beauty. \n\nCrafted for comfort and durability, this sweatshirt is soft enough for everyday wear and sturdy enough for active kids.\n\nDetails:\nCustom embroidered town and state\nChoose your own embroidery colors or request a curated color combo (I have a formula!)\nClassic unisex fit\nSoft, cozy fleece interior\nDurable embroidery made to last through washes and play\nSizes available: 2T – Youth XL\n\nWhy boutiques love it:\nEasy customization for local towns, vacation destinations, and school communities\nStrong gift and souvenir appeal\nMade by a small, woman-owned business\nEasyTear™ label",
  tags: [],
  msrpDollars: 52.66,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:15.073Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
